/* global window */
import { navigate } from 'gatsby';

export default function redirect(path = '/', replace = true) {
  if (typeof window === 'undefined') return;
  navigate(path, { replace });
}
